import clone from 'clone';

export class CloneHelper {
	clone<T>(val: T): T {
		return clone(val);
	}
}

export const cloneHelper = new CloneHelper();
